import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7829a2bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("techfx88.com")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("测试服token请求")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("正式服token请求")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("sylapp.cn")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("正式服token请求")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_typography_title, { level: 4 }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_a_space, { size: _ctx.size }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: _ctx.fdzqdev }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, { onClick: _ctx.fdzqpro }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["size"]),
    _createElementVNode("p", null, "测试服token请求：" + _toDisplayString(_ctx.fdzqdevData), 1),
    _createElementVNode("p", null, "正式服token请求：" + _toDisplayString(_ctx.fdzqproData), 1),
    _createVNode(_component_a_typography_title, { level: 4 }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_a_space, { size: _ctx.size }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: _ctx.sylapppro }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["size"]),
    _createElementVNode("p", null, "正式服token请求：" + _toDisplayString(_ctx.sylappproData), 1)
  ]))
}